module.exports = Backbone.Model.extend({
	urlRoot: App.mindRoot + 'posts'
})
